<mat-icon
  *ngIf="!noDealerPriceIcon; else tooltipForNoDealerPrice"
  [class.material-icons-outlined]="matIconTheme === 'material-icons-outlined'"
  [class.material-icons-sharp]="matIconTheme === 'material-icons-sharp'"
  [class.size-16]="size === '16'"
  [svgIcon]="!matIconName ? svgIconName : null"
  [popoverTriggerFor]="tooltip"
  [placement]="placement"
  [trigger]="isMobile || isTablet ? 'click' : 'hover'"
  [popoverClass]="['tooltip-icon', activeLanguage$ | async, 'code-' + uniqueClass]"
  [isMobile]=""
  [closeOnScroll]="closeOnScroll"
  [autoPlacement]="true"
  alignToCenter="true"
  [noArrow]="true"
  [shadow]="true"
  maxWidth="250px"
  pointerEvents="auto"
  (events)="emitEvents($event)"
  >{{ matIconName ? matIconName : null }}</mat-icon
>
<ng-template #tooltipForNoDealerPrice>
  <div
    [ngClass]="['no-dealer-price', dealerPriceIconContainerClass]"
    [popoverTriggerFor]="tooltip"
    [placement]="placement"
    [trigger]="isMobile || isTablet ? 'click' : 'hover'"
    [popoverClass]="['tooltip-icon', activeLanguage$ | async, 'code-' + uniqueClass]"
    [isMobile]=""
    [closeOnScroll]="closeOnScroll"
    [autoPlacement]="true"
    alignToCenter="true"
    [noArrow]="true"
    [shadow]="true"
    maxWidth="250px"
    pointerEvents="auto"
    (events)="emitEvents($event)"
    (click)="onClickTooltipIcon($event)"
  ></div>
</ng-template>
<popover #tooltip [innerHtml]="tooltipContent"></popover>
